import style from "./FurnitureImage.module.scss"

const { imageArea, placeholder } = style

type Props = {
	imageUrl?: string | null
	isCountertop: boolean
	hasModelNumber: boolean
}

export const FurnitureImage = ({ imageUrl, isCountertop, hasModelNumber }: Props) => {
	if (isCountertop) {
		return (
			<div className={imageArea}>
				<p className={placeholder}>Images are not supported for countertop</p>
			</div>
		)
	}

	if (imageUrl) {
		return (
			<div className={imageArea}>
				<img src={imageUrl} alt="Object" />
			</div>
		)
	}

	return (
		<div className={imageArea}>
			<p className={placeholder}>
				{hasModelNumber ? "No image available" : "The image will appear once model number is selected"}
			</p>
		</div>
	)
}
